import React, {useState} from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
    ContentCopyOutlined,
  FeedOutlined,
  FileDownloadOutlined,
  InsertLinkOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
  Alert,
  Snackbar
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function DevHub() {
    const theme = useTheme();
    const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
    const [openSnackbar, setOpenSnackbar] = useState(false);

  function CopyToClipboard(textToCopy, url) {
  navigator.clipboard.writeText(textToCopy).then(
      function() {
        console.log('Copying to clipboard was successful!');
        setOpenSnackbar(true); // Open the Snackbar
      }, 
      function(err) {
        console.error('Could not copy text: ', err);
      }
    );

    if (url) {
      window.open(url, '_blank');
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };
    
  return (
    <Box m="1.5rem 2.5rem">
        <FlexBetween>
            <Header title="FLAIR FLOW SISU" subtitle="Business Info" />
            <Box></Box>
        </FlexBetween>

        <Box
            mt="30px"
            display="grid"
            gap={4}
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="100px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 1 */}
            <SceneBox
            value="Info (societe.com)"
            onClick={() => {
                    window.open('https://www.societe.com/societe/flair-flow-952713873.html');
                }}
            icon={
                <InsertLinkOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            
            />
            
            <SceneBox
                value="SIRET: 95271387300018"
                  onClick={() => CopyToClipboard('95271387300018')}
            icon={
                <ContentCopyOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
              />
            <SceneBox
            value="SIREN: 952713873"
                onClick={() => CopyToClipboard('952713873')}
            icon={
                <ContentCopyOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="TVA: FR62952713873"
            onClick={() => CopyToClipboard('FR62952713873')}
            icon={
                <ContentCopyOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
              />
            <SceneBox
            value="KBIS (PDF)"
            onClick={() => {
                    window.open('https://drive.google.com/file/d/1WquUtbirYoCGPZUOytboV_YlmRUhnd-q/view?usp=drive_link');
                }}
            icon={
                <FileDownloadOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
              />
              <Snackbar 
                    open={openSnackbar} 
                    autoHideDuration={6000} 
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                    Copied to clipboard!
                    </Alert>
                </Snackbar>
        </Box>
            
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Bank" />
            <Box>
            </Box>
        </FlexBetween>
        <Box
            mt="30px"
            display="grid"
            gap={4}
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="100px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
              {/* ROW 2 */}
              <SceneBox
            value="Bank Access"
            onClick={() => window.open('https://www.cic.fr/fr/authentification.html')}
            icon={
                <ContentCopyOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Account info"
            onClick={() => CopyToClipboard('Détails Bancaires | Banque: CIC Titulaire: FLAIR FLOW SASU RIB: FR7630066102810002071690287 BIC: CMCIFRPP')}
            icon={
                <ContentCopyOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="RIB (PDF)"
            onClick={() => {
                    window.open('https://drive.google.com/file/d/11w5UeToJEYyV4TXPKjdBDZdtuJhpFO40/view?usp=drive_link');
                }}
            icon={
                <FileDownloadOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
        </Box>
          
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Certificate" />
            <Box>
            </Box>
        </FlexBetween>
        <Box
            mt="30px"
            display="grid"
            gap={4}
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="100px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 4 */}
            <SceneBox
            value="HACCP"
            onClick={() => {
                    window.open('https://drive.google.com/file/d/1vVof-D7_0onSq7CS4uTG9xtMWiZUgDQ8/view?usp=drive_link');
                }}
            icon={
                <FeedOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Debit de Boissons"
            onClick={() => {
                    window.open('https://drive.google.com/file/d/1ofHgDhi2iM2REOlGABGPoCZqWz09w2V_/view?usp=drive_link');
                }}
            icon={
                <FeedOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />              
        </Box>
          
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Insurance" />
            <Box>
            </Box>
        </FlexBetween>
        <Box
            mt="30px"
            display="grid"
            gap={4}
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="100px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 4 */}
            <SceneBox
            value="Insurance Document (PDF)"
            onClick={() => {
                    window.open('https://drive.google.com/file/d/17TrUos-waXOLxk_I_5qcopT6EbNyubyj/view?usp=drive_link');
                }}
            icon={
                <FileDownloadOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
              />
        </Box>
    </Box>
  );
};